import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import './styles.scss';

interface FooterLinkProps {
	text: string;
	link: string;
	isExternal: boolean;
}

const FooterLink: React.FC<FooterLinkProps> = (props: FooterLinkProps) => {
	const { t } = useTranslation();
	const { text, link, isExternal } = props;

	return (
		<li className="footerLink">
			{isExternal ? (
				<a className="footerLink__link" target="_blank" rel="noreferrer" data-cy="footer-link" href={link}>
					{t(text)}
				</a>
			) : (
				<NavLink to={link} className="footerLink__link" data-cy="footer-link">
					{t(text)}
				</NavLink>
			)}
		</li>
	);
};
export default FooterLink;
